<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<h1 mat-dialog-title class="mat-dialog-container__title">
  {{ 'NGX-MESSAGING.searchYourGif' | translate | uppercase }}
</h1>
<div class="modal-container" mat-dialog-content>
  <mat-form-field appearance="fill" class="full-width-input">
    <input matInput placeholder="{{ 'NGX-MESSAGING.searchYourGif' | translate }}" #search />
  </mat-form-field>
  <div
    class="gifs-container"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="20"
    [infiniteScrollContainer]="'.modal-container'"
    (scrolled)="onScroll()"
    [fromRoot]="true">
    @for (gif of gifs(); track gif.id) {
    <div class="gifs-container__gif" (click)="selectGif(gif)">
      <img [ngClass]="{ 'gifs-container__gif--selected': gif.id === gifSelected()?.id }" [src]="gifUrl(gif)" alt="Image" />
    </div>
    }
  </div>
  @if (isLoading()) {
  <div class="loading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
  }
</div>

<div class="modal-actions" mat-dialog-actions>
  <button [disabled]="!gifUrl(gifSelected())" mat-raised-button color="primary" (click)="sendResponse()">
    <mat-icon svgIcon="send"></mat-icon>
    {{ 'NGX-MESSAGING.sendGif' | translate }}
  </button>
</div>
